export default {
  name: 'wisk-plus',
  width: 35,
  height: 35,
  paths: [
    { d: 'M34.992,17.5a2.409,2.409,0,0,1-2.413,2.412H19.921V32.587a2.413,2.413,0,0,1-4.826,0V19.912H2.421a2.413,2.413,0,1,1,0-4.825H15.1V2.413a2.413,2.413,0,0,1,4.826,0V15.087H32.579A2.41,2.41,0,0,1,34.992,17.5Z' }
  ]
}
